import React, { useEffect, useState, Fragment } from 'react'
import { Button, Container, Tab, Tabs } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import Conductor from '../Conductor'
import Implicado from '../Implicado'
import Propietario from '../Propietario'
import Destinatario from '../Destinatario'
import { isValidParam } from '../../../../common/Formatos'

const TabsModal = ({ formik, setRutConductorFinal, setRutPropietarioFinal, setPaisImplicadoFinal, isImplicado, handleShowProp, setHandleShowProp, tipoInvolucradoTmp,
  stateChkConductor, setStateChkConductor, stateChkPropietario, setStateChkPropietario, setIdCiudadImplicado
 }) => {
  const [key, setKey] = useState('implicado')
  const [tipoPerdida, setTipoPerdida] = useState('')

  // El hook useSelector (redux) permite acceder al state en nuestro store.
  const data_datos_generales = useSelector((state) => state.casoGeneralReducer)
  const data_datos_implicado = useSelector((state) => state.implicadoReducer)
  const { datosPantalla, cfg_form37} = data_datos_implicado
  const { antecedentesCasos, cfg_form_implicado } = data_datos_generales

  const [tipoInvolucradoBD, setTipoInvolucradoBD] = useState('')
  const [bloqueaConductor, setBloqueaConductor] = useState(false)
  const [bloqueaPropietario, setBloqueaPropietario] = useState(false)

  const dispatch = useDispatch()

  useEffect(() => {
    if (antecedentesCasos && antecedentesCasos.antecedentesCasos[0]['IdTipoSiniestro'] === 15005) {
      setTipoPerdida('Parcial')
    } else {
      setTipoPerdida('Total')
    }
  }, [antecedentesCasos])

  useEffect(() => {
    if (datosPantalla && datosPantalla && datosPantalla?.datosPantalla[0] && isValidParam(datosPantalla?.datosPantalla[0]['TipoInvolucrado'])) {
      setTipoInvolucradoBD(datosPantalla.datosPantalla[0]['TipoInvolucrado']);
    } else {
      setTipoInvolucradoBD('');
    }
  }, [datosPantalla])

  useEffect(() => {
    if (isImplicado && (tipoInvolucradoTmp != 205001 || stateChkConductor)) {//Corresponde a un ingreso de implicado
      setBloqueaConductor(true);
    } else {
      setBloqueaConductor(false);
    }

    if (!isImplicado) {//Corresponde a una edición de implicado
      if (!isValidParam(tipoInvolucradoTmp) && tipoInvolucradoBD != 205001 || stateChkConductor) {
        setBloqueaConductor(true);
      }
      if (isValidParam(tipoInvolucradoTmp) && tipoInvolucradoTmp != 205001 || stateChkConductor) {
        setBloqueaConductor(true);
      }
    }
  }, [stateChkConductor, tipoInvolucradoBD, tipoInvolucradoTmp])

  useEffect(() => {
    if (isImplicado && (tipoInvolucradoTmp != 205001 || stateChkPropietario)) {//Corresponde a un ingreso de implicado
      setBloqueaPropietario(true);
    } else {
      setBloqueaPropietario(false);
    }

    if (!isImplicado) {//Corresponde a una edición de implicado
      if (!isValidParam(tipoInvolucradoTmp) && tipoInvolucradoBD != 205001 || stateChkPropietario) {
        setBloqueaPropietario(true);
      }
      if (isValidParam(tipoInvolucradoTmp) && tipoInvolucradoTmp != 205001 || stateChkPropietario) {
        setBloqueaPropietario(true);
      }
    }
  }, [stateChkPropietario, tipoInvolucradoBD, tipoInvolucradoTmp])

  return (
    <>
      <style type='text/css'>
        {`
          .nav-tabs .nav-item.show .nav-link, .nav-tabs .nav-link.active {
            color: white;
            background-color: #01CECA;          
          }
          .nav-tabs {
            border-Bottom: 1px solid #253B6D;             
          }
          .nav-item{            
            color: #d9d9d9;
            border: 1px solid #01CECA;
            border-radius:5px 5px 0px 0px;  
            margin-right:2px;         
            border-Bottom:none;                        
          }
          .nav-tabs .nav-link:hover{
            color:white;
            background-color: #01CECA;                          
          }
     `}
      </style>
      <Container>
        <Container>
          <Tabs
            className='nav-tabs'
            activeKey={key}
            id='uncontrolled-tab-example'
            onSelect={(k) => {
              setKey(k)
            }}
          >
            <Tab.Pane
              eventKey='implicado'
              title={cfg_form37 ? cfg_form37.cfg_form37['casograldefensa-editimpl-title-implicado'] : null}
            >
              <Implicado
                formik={formik}
                isImplicado={isImplicado}
                setPaisImplicadoFinal={setPaisImplicadoFinal}
                handleShowProp={handleShowProp}
                setHandleShowProp={setHandleShowProp}
                tipoInvolucradoTmp={tipoInvolucradoTmp}                
                tipoInvolucradoBD={tipoInvolucradoBD}
                stateChkConductor={stateChkConductor}
                setStateChkConductor={setStateChkConductor}
                stateChkPropietario={stateChkPropietario}
                setStateChkPropietario={setStateChkPropietario}
                setIdCiudadImplicado={setIdCiudadImplicado}
              />
            </Tab.Pane>
            <Tab.Pane
              eventKey='conductor'
              title={cfg_form37 ? cfg_form37.cfg_form37['casograldefensa-editimpl-title-cond'] : null}
              disabled = {bloqueaConductor}
            >
              <Conductor
                isImplicado={isImplicado}
                formik={formik}
                setRutConductorFinal={setRutConductorFinal}
                handleShowProp={handleShowProp}
                setHandleShowProp={setHandleShowProp}                             
              />
            </Tab.Pane>
            <Tab.Pane
              eventKey='propietario'
              title={cfg_form37 ? cfg_form37.cfg_form37['casograldefensa-editimpl-title-prop'] : null}
              disabled = {bloqueaPropietario}
            >
              <Propietario formik={formik} setRutPropietarioFinal={setRutPropietarioFinal}
                isImplicado={isImplicado}
                handleShowProp={handleShowProp}
                setHandleShowProp={setHandleShowProp}                
              />
            </Tab.Pane>
            <Tab.Pane
              eventKey='destinatario'
              title={cfg_form37 ? cfg_form37.cfg_form37['casograldefensa-editimpl-title-dest-pago'] : null}
            >
              <Destinatario formik={formik} setRutPropietarioFinal={setRutPropietarioFinal}
                isImplicado={isImplicado}
                handleShowProp={handleShowProp}
                setHandleShowProp={setHandleShowProp}
              />
            </Tab.Pane>
          </Tabs>
        </Container>
      </Container>
    </>
  )
}

export default TabsModal
